module.exports = __webpack_public_path__ + "img/book-open-cover.14fe1fd5.svg";